// 이벤트 버스 생성 컴포넌트
import { EventEmitter } from 'events';

const EventBus = new EventEmitter();

export default EventBus;
